import React from "react";
import { useHistory } from "react-router-dom";
import { Button, AgGrid, DropdownButton } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import {
  useComplianceEntityOnboardingEnabled,
  useGuidedProfileCreation,
} from "~/pages/Compliance/flags";
import ExportActionsComponent from "../../ExportActions";

interface Props {
  showCreateNewCaseButton: boolean;
  gridApi?: AgGrid.GridApi<any>;
}

const CaseButton: React.FC<Props> = ({ showCreateNewCaseButton, gridApi }) => {
  const history = useHistory();
  const guidedProfileCreation = useGuidedProfileCreation();
  const entityOnboardingEnabled = useComplianceEntityOnboardingEnabled();

  const pushInvestorCreate = () => {
    if (guidedProfileCreation) {
      history.push(`${globalEnv.complianceRoute}/create-case/investor`);
    } else {
      history.push(`${globalEnv.complianceRoute}/create-case`);
    }
  };

  if (!showCreateNewCaseButton) {
    return <ExportActionsComponent gridApi={gridApi} />;
  }

  if (entityOnboardingEnabled) {
    return (
      <DropdownButton
        label="Create new case"
        icon="plus"
        variant="primary"
        align="right"
        data-testid="create-new-case-dropdown"
      >
        <DropdownButton.Action
          onSelect={pushInvestorCreate}
          data-cy="create-investor-onboarding-case"
        >
          Investor onboarding
        </DropdownButton.Action>
        <DropdownButton.Action
          onSelect={() => history.push(`${globalEnv.complianceRoute}/create-case/entity`)}
          data-cy="create-entity-onboarding-case"
        >
          Entity onboarding
        </DropdownButton.Action>
        <DropdownButton.Action
          onSelect={() => history.push(`${globalEnv.complianceRoute}/create-case/client`)}
          data-cy="create-client-onboarding-case"
        >
          Client onboarding
        </DropdownButton.Action>
      </DropdownButton>
    );
  }

  return (
    <Button icon="plus" variant="primary" onClick={pushInvestorCreate}>
      Create new case
    </Button>
  );
};

export default CaseButton;
